import {Validators} from '@angular/forms';

import {
    AddressDocumentTypesEnum,
    IdentityDocumentTypesEnum,
    DocumentTypesEnum,
    DocumentStatusesEnum,
    DocumentFilterModel,
    DocumentReportModel
} from '@spa/api';

import {LatinDigitsValidator} from '@spa/validators';

import {ColorCodesEnum, ComponentTypesEnum, UnspecifiedKeysEnum} from '../../app/shared/enums';
import {ReportTableColumn, ReportTableConfigInterface, ReportTableData} from '../../app/shared/components';
import {BaseControl, CheckboxControl, DatepickerControl, FilterControl, Helper, SelectControl} from '../../app/shared/classes';

import {EnrollTypesEnum, IsHiddenForClientDocumentEnum} from '../../app/entries/panel/enums';

export const DocumentIdPathSelector = 'documentId';
export const DocumentFilterExpirationDateSelector = 'documentFilterExpirationDate';
export const IsCorporateDocumentSelector = 'isCorporateDocument';
export const IndividualDocumentSelector = 'individual';
export const CorporateDocumentSelector = 'corporate';

export const DocumentsEditSubTypeSelector = 'documentsEditSubType';
export const DocumentsEditStatusSelector = 'documentsEditStatus';
export const DocumentsEditNumberSelector = 'documentsEditNumber';
export const DocumentsEditExpiresAtSelector = 'documentsEditExpiresAt';
export const DocumentsEditDescriptionSelector = 'documentsEditDescription';
export const DocumentsEditVisibleForClientSelector = 'documentsEditHiddenForClient';
export const PanelDocumentsStorageId = 'PanelDocumentsComponent';
export const PanelClientsEditDocumentsStorageId = 'PanelClientsEditDocumentsComponent';

export const PanelDocumentsFilterControls = (): FilterControl[] => {
    return [
        new FilterControl({
            name: DocumentFilterModel.getDescriptionSelector(),
            placeholder: 'Description',
            controls: [
                new BaseControl({
                    name: DocumentFilterModel.getDescriptionSelector(),
                    value: null,
                    placeholder: 'Description',
                    validators: [Validators.minLength(3)],
                    componentType: ComponentTypesEnum.Text
                }),
            ],
            sortIndex: 1
        }),
        new FilterControl({
            name: DocumentFilterModel.getDocumentTypesSelector(),
            placeholder: 'Document Sub type',
            controls: [
                new SelectControl({
                    name: DocumentFilterModel.getDocumentTypesSelector(),
                    value: UnspecifiedKeysEnum.UnspecifiedDocumentKey,
                    placeholder: 'Document Sub type',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: 'All',
                            value: UnspecifiedKeysEnum.UnspecifiedDocumentKey
                        },
                        {
                            label: Helper.enumsHelper().getProofOfIdentityDocumentTypes()
                                .getTypeValue(IdentityDocumentTypesEnum.DrivingLicense),
                            value: IdentityDocumentTypesEnum.DrivingLicense
                        },
                        {
                            label: Helper.enumsHelper().getProofOfIdentityDocumentTypes()
                                .getTypeValue(IdentityDocumentTypesEnum.IdentityCard),
                            value: IdentityDocumentTypesEnum.IdentityCard
                        },
                        {
                            label: Helper.enumsHelper().getProofOfIdentityDocumentTypes()
                                .getTypeValue(IdentityDocumentTypesEnum.Passport),
                            value: IdentityDocumentTypesEnum.Passport
                        },
                        {
                            label: Helper.enumsHelper().getProofOfAddressDocumentTypes()
                                .getTypeValue(AddressDocumentTypesEnum.BankStatement),
                            value: AddressDocumentTypesEnum.BankStatement
                        },
                        {
                            label: Helper.enumsHelper().getProofOfAddressDocumentTypes()
                                .getTypeValue(AddressDocumentTypesEnum.UtilityBill),
                            value: AddressDocumentTypesEnum.UtilityBill
                        },
                        {
                            label: Helper.enumsHelper().getDocumentTypes().getTypeValue(DocumentTypesEnum.Selfie),
                            value: DocumentTypesEnum.Selfie
                        },
                        {
                            label: Helper.enumsHelper().getMarketDataAgreementDocumentTypes()
                            .getTypeValue(DocumentTypesEnum.MarketDataAgreement),
                            value: DocumentTypesEnum.MarketDataAgreement
                        },
                        {
                            label: Helper.enumsHelper().getCompanyDocumentTypes()
                                .getTypeValue(DocumentTypesEnum.CertificateOfIncorporation),
                            value: DocumentTypesEnum.CertificateOfIncorporation
                        },
                        {
                            label: Helper.enumsHelper().getCompanyDocumentTypes()
                                .getTypeValue(DocumentTypesEnum.CertificateOfCurrentStanding),
                            value: DocumentTypesEnum.CertificateOfCurrentStanding
                        },
                        {
                            label: Helper.enumsHelper().getCompanyDocumentTypes()
                                .getTypeValue(DocumentTypesEnum.ArticleOfAssociation),
                            value: DocumentTypesEnum.ArticleOfAssociation
                        },
                        {
                            label: Helper.enumsHelper().getCompanyDocumentTypes()
                                .getTypeValue(DocumentTypesEnum.MemorandumOfAssociation),
                            value: DocumentTypesEnum.MemorandumOfAssociation
                        },
                        {
                            label: Helper.enumsHelper().getCompanyDocumentTypes()
                                .getTypeValue(DocumentTypesEnum.RegisterOfDirectors),
                            value: DocumentTypesEnum.RegisterOfDirectors
                        },
                        {
                            label: Helper.enumsHelper().getCompanyDocumentTypes()
                                .getTypeValue(DocumentTypesEnum.RegisterOfShareholders),
                            value: DocumentTypesEnum.RegisterOfShareholders
                        }
                    ]
                }),
            ],
            sortIndex: 2
        }),
        new FilterControl({
            name: DocumentFilterModel.getDocumentStatusesSelector(),
            placeholder: 'Document status',
            controls: [
                new SelectControl({
                    name: DocumentFilterModel.getDocumentStatusesSelector(),
                    value: DocumentStatusesEnum.All,
                    placeholder: 'Document status',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: Helper.textsHelper().getDocumentStatusName(DocumentStatusesEnum.All),
                            value: DocumentStatusesEnum.All
                        },
                        {
                            label: Helper.textsHelper().getDocumentStatusName(DocumentStatusesEnum.New),
                            value: DocumentStatusesEnum.New
                        },
                        {
                            label: Helper.textsHelper().getDocumentStatusName(DocumentStatusesEnum.InReview),
                            value: DocumentStatusesEnum.InReview
                        },
                        {
                            label: Helper.textsHelper().getDocumentStatusName(DocumentStatusesEnum.Approved),
                            value: DocumentStatusesEnum.Approved
                        },
                        {
                            label: Helper.textsHelper().getDocumentStatusName(DocumentStatusesEnum.Archived),
                            value: DocumentStatusesEnum.Archived
                        },
                        {
                            label: Helper.textsHelper().getDocumentStatusName(DocumentStatusesEnum.Expired),
                            value: DocumentStatusesEnum.Expired
                        },
                        {
                            label: Helper.textsHelper().getDocumentStatusName(DocumentStatusesEnum.Declined),
                            value: DocumentStatusesEnum.Declined
                        }
                    ]
                }),
            ],
            sortIndex: 3
        }),
        new FilterControl({
            name: DocumentFilterModel.getEnrollTypeSelector(),
            placeholder: 'Client Type',
            controls: [
                new SelectControl({
                    name: DocumentFilterModel.getEnrollTypeSelector(),
                    value: EnrollTypesEnum.All,
                    placeholder: 'Client Type',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: Helper.textsHelper().getEnrollTypeName(EnrollTypesEnum.All),
                            value: EnrollTypesEnum.All
                        },
                        {
                            label: Helper.textsHelper().getEnrollTypeName(EnrollTypesEnum.Individual),
                            value: EnrollTypesEnum.Individual
                        },
                        {
                            label: Helper.textsHelper().getEnrollTypeName(EnrollTypesEnum.Corporate),
                            value: EnrollTypesEnum.Corporate
                        },
                    ]
                })
            ],
            sortIndex: 4
        }),
        new FilterControl({
            name: DocumentFilterModel.getEnrollNameSelector(),
            placeholder: 'Client name',
            controls: [
                new BaseControl({
                    name: DocumentFilterModel.getEnrollNameSelector(),
                    value: null,
                    placeholder: 'Client name',
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                }),
            ],
            sortIndex: 5
        }),
        new FilterControl({
            name: DocumentFilterExpirationDateSelector,
            placeholder: 'Expiration Date',
            controls: [
                new DatepickerControl({
                    name: DocumentFilterModel.getExpirationDateFromSelector(),
                    value: null,
                    placeholder: 'Expiration date from',
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 1
                }),
                new DatepickerControl({
                    name: DocumentFilterModel.getExpirationDateToSelector(),
                    value: null,
                    placeholder: 'Expiration date to',
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 2
                }),
            ],
            sortIndex: 6
        }),
        new FilterControl({
            name: DocumentFilterModel.getCreatedDateSelector(),
            placeholder: 'Created date',
            controls: [
                new DatepickerControl({
                    name: DocumentFilterModel.getCreatedDateSelector(),
                    value: null,
                    placeholder: 'Created date',
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker
                })
            ],
            sortIndex: 7
        }),
        new FilterControl({
            name: DocumentFilterModel.getIsHiddenForClientSelector(),
            placeholder: 'Is hidden for client',
            controls: [
                new SelectControl({
                    name: DocumentFilterModel.getIsHiddenForClientSelector(),
                    value: IsHiddenForClientDocumentEnum.All,
                    placeholder: 'Is hidden for client',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: 'All',
                            value: IsHiddenForClientDocumentEnum.All
                        },
                        {
                            label: 'No',
                            value: IsHiddenForClientDocumentEnum.No
                        },
                        {
                            label: 'Yes',
                            value: IsHiddenForClientDocumentEnum.Yes
                        }

                    ]
                })
            ],
            sortIndex: 8
        }),
    ];
};

export const PanelDocumentsDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<number>({
            colId: DocumentReportModel.getDocumentTypeSelector(),
            value: null,
            hidden: false

        }),
        new ReportTableData<number>({
            colId: DocumentReportModel.getDocumentSubTypeSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: DocumentReportModel.getDocumentStatusSelector(),
            value: null,
            hidden: false

        }),
        new ReportTableData<string>({
            colId: DocumentReportModel.getNameSelector(),
            value: null,
            hidden: false

        }),
        new ReportTableData<string>({
            colId: DocumentReportModel.getIsHiddenForClientSelector(),
            value: null,
            hidden: false

        }),
        new ReportTableData<string>({
            colId: DocumentReportModel.getExpirationDateSelector(),
            value: null,
            hidden: false

        }),
        new ReportTableData<string>({
            colId: DocumentReportModel.getUploadedStampSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: DocumentReportModel.getDescriptionSelector(),
            value: null,
            hidden: false
        })
    ];
};

export const PanelDocumentsDataTableConfig: ReportTableConfigInterface = {
    rows: [],
    columns: [
        new ReportTableColumn({
            label: 'Document Type',
            selector: DocumentReportModel.getDocumentTypeSelector()
        }),
        new ReportTableColumn({
            label: 'Sub Type',
            selector: DocumentReportModel.getDocumentSubTypeSelector()
        }),
        new ReportTableColumn({
            label: 'Document Status',
            selector: DocumentReportModel.getDocumentStatusSelector()
        }),
        new ReportTableColumn({
            label: 'Client',
            selector: DocumentReportModel.getNameSelector()
        }),
        new ReportTableColumn({
            label: 'Visible For Client',
            selector: DocumentReportModel.getIsHiddenForClientSelector()
        }),
        new ReportTableColumn({
            label: 'Expiration date',
            selector: DocumentReportModel.getExpirationDateSelector()
        }),
        new ReportTableColumn({
            label: 'Created Date',
            selector: DocumentReportModel.getUploadedStampSelector()
        }),
        new ReportTableColumn({
            label: 'Description',
            selector: DocumentReportModel.getDescriptionSelector()
        })
    ],
    hiddenColumnIds: [],
    actionMenu: false,
};


export const DocumentsEditControls = (): BaseControl[] => {
    return [
        new SelectControl({
            name: DocumentsEditSubTypeSelector,
            value: null,
            placeholder: 'Document Sub Type',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            options: [],
            floatingLabelNever: true
        }),
        new SelectControl({
            name: DocumentsEditStatusSelector,
            value: null,
            placeholder: 'Status',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: [],
            floatingLabelNever: true
        }),
        new BaseControl({
            name: DocumentsEditNumberSelector,
            value: null,
            placeholder: 'Document number',
            validators: [LatinDigitsValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        }),
        new DatepickerControl({
            name: DocumentsEditExpiresAtSelector,
            value: null,
            placeholder: 'Expiration date',
            validators: [],
            componentType: ComponentTypesEnum.LockableDatepicker,
            more: {
                texts: ['Non-expiring', 'Expiring']
            },
            floatingLabelNever: true
        }),
        new CheckboxControl({
            name: DocumentsEditVisibleForClientSelector,
            value: null,
            placeholder: 'Visible For Client',
            validators: [],
            componentType: ComponentTypesEnum.Checkbox,
            checked: false,
            color: ColorCodesEnum.Primary,
            expectBooleanValue: true
        }),
        new BaseControl({
            name: DocumentsEditDescriptionSelector,
            value: null,
            placeholder: 'Description',
            validators: [LatinDigitsValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        }),
    ];
};
